import { Flex, Box, Image, Text, useDisclosure } from '@chakra-ui/react';
import { PiGarageFill } from 'react-icons/pi';
import { MdToken } from 'react-icons/md';
import { SiSpeedtest } from 'react-icons/si';
import { IoIosSettings } from 'react-icons/io';
import { TbLayoutDashboard } from 'react-icons/tb';
import { AiFillStar } from 'react-icons/ai';
import { FaOilCan } from "react-icons/fa";
import { RiShoppingBasket2Fill } from "react-icons/ri";
import { MdLeaderboard } from "react-icons/md";

import { parseNum } from '../../../services/Utils';
import GarageModal from '../modals/GarageModal.js';
import AchievementsModal from '../modals/AchievementsModal.js';
import InfoModal from '../modals/InfoModal.js';
import MarketModal from '../modals/MarketModal.js';
import LeadersModal from '../modals/LeadersModal.js';

const TopBar = ({
	speedNum,
	tokens,
  allTokens,
  setTokens,
	cars,
  setViewMode,
  InfoIsOpen,
  InfoOnOpen,
  InfoOnClose,
	activeCar,
	setActiveCar,
  colors, 
  activeColors, 
  setActiveColors,
	pedals,
  activePedals,
  pedalsIsAuto, 
  setPedalsIsAuto,
  setActivePedals,
  setIsAccelerating,
  isAccelerating,
  category,
  setCategory,
  GarageIsOpen,
  GarageOnOpen,
  GarageOnClose
}) => {
  const attentionModal = async () => {
    onOpen();
  };

  //const { isOpen: GarageIsOpen, onOpen: GarageOnOpen, onClose: GarageOnClose } = useDisclosure();
  const { isOpen: AchievementsIsOpen, onOpen: AchievementsOnOpen, onClose: AchievementsOnClose } = useDisclosure();
  const { isOpen: MarketIsOpen, onOpen: MarketOnOpen, onClose: MarketOnClose } = useDisclosure();
  const { isOpen: LeadersIsOpen, onOpen: LeadersOnOpen, onClose: LeadersOnClose } = useDisclosure();

  return (
    <Flex gap="10px" position="absolute" w="100%" zIndex="9" p="100px 20px 40px 20px">
      <Flex justify="start" gap="24px" w="100%" overflow="initial">
        <Box className="neonIcon-yellow">
          <AiFillStar 
            color="gray.10" 
            fontSize="32px" 
            style={{ margin: '9px 0px -9px -1px'}} 
            className="rotateAnim" 
            onClick={() => {AchievementsOnOpen(); setIsAccelerating(false)}} />
        </Box>

        <Box className="neonIcon-bluegreen" m="8px 8px 8px -2px">
          <FaOilCan 
            color="gray.10" 
            style={{transform: 'rotate(-45deg)', margin: '9px 0px 0px 9px'}} 
            fontSize="32px" 
            onClick={() => {InfoOnOpen(); setIsAccelerating(false)}} />
        </Box>

        <Box 
          position="absolute"
          m="50px 0 0 50px"
          className="neonIcon-purple">
          <PiGarageFill
            color="gray.10" 
            style={{transform: 'rotate(-45deg)', margin: '9px 0px 0px 9px'}} 
            fontSize="32px" 
            onClick={() => {GarageOnOpen(); setIsAccelerating(false)}} />
        </Box>

        {/*<Box 
          position="absolute"
          m="91px 0 0 8px"
          className="neonIcon-blue">
          <MdLeaderboard
            color="gray.10" 
            style={{transform: 'rotate(-45deg)', margin: '10px 0px 0px 10px'}} 
            fontSize="28px" 
            onClick={() => {LeadersOnOpen(); setIsAccelerating(false)}} />
        </Box>*/}
      </Flex>

      <Box w="172px" textAlign="right">
      	<Flex gap="10px" justify="end">
      		<Text variant="title-lg" mt="2px" color="#dd1650" fontSize="23px">{parseNum(tokens)}</Text>
      		<Box className="opacityAnim"><MdToken color="#dd1650" fontSize="38px" /></Box>
      	</Flex>
      	<Text variant="title-lg" fontSize="48px" fontFamily="monospace" fontStyle="italic">{Math.floor(speedNum / 0.621371)}</Text>
      	<Flex gap="4px" justify="end" mt="-5px" pr="2px">
      		<Text variant="text-md" mt="-1px" pr="2px" fontStyle="italic">KM/H</Text>
      		<SiSpeedtest fontSize="18px" color="#bdbdbd" />
      	</Flex>
      </Box>

      <GarageModal
        isOpen={GarageIsOpen}
        onOpen={GarageOnClose}
        onClose={GarageOnClose}
        cars={cars}
        setViewMode={setViewMode}
        tokens={tokens} 
        setTokens={setTokens}
        activeCar={activeCar}
        setActiveCar={setActiveCar}
        colors={colors}
        activeColors={activeColors}
        setActiveColors={setActiveColors}
        pedals={pedals}
        pedalsIsAuto={pedalsIsAuto}
        setPedalsIsAuto={setPedalsIsAuto}
	      activePedals={activePedals}
	      setActivePedals={setActivePedals}
        category={category}
        setCategory={setCategory}
      />

      <AchievementsModal
        tokens={tokens}
        allTokens={allTokens}
        cars={cars}
        colors={colors}
        pedals={pedals}
        isOpen={AchievementsIsOpen}
        onOpen={AchievementsOnOpen}
        onClose={AchievementsOnClose}
      />

      <MarketModal
        tokens={tokens}
        allTokens={allTokens}
        isOpen={MarketIsOpen}
        onOpen={MarketOnOpen}
        onClose={MarketOnClose}
      />

      <LeadersModal
        tokens={tokens}
        allTokens={allTokens}
        isOpen={LeadersIsOpen}
        onOpen={LeadersOnOpen}
        onClose={LeadersOnClose}
      />

      <InfoModal 
        isOpen={InfoIsOpen}
        onOpen={InfoOnOpen}
        onClose={InfoOnClose}
      />
    </Flex>
  );
};

export default TopBar;
